<template>
  <div>
    <admin-wrapper
      :straight-title="additionalModuleName"
      :module-enabler="moduleEnabler"
      :is-form-fetched="isFetched"
      :inputs="inputs"
      :has-buttons="false"
    >
      <template #sqlView.input="data">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col class="font-weight-medium text-left">
                {{ $i18n.t('admin.registerDataSource') }}
              </v-col>
            </v-row>
            <v-row align="baseline" no-gutters>
              <v-col cols="4" class="pt-5">
                <data-input v-model="sqlView" v-bind="data" />
              </v-col>
              <v-col cols="auto">
                <base-button translation-path="admin.register" class="ml-5" :disabled="!sqlView" @click="openDialog" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </admin-wrapper>
    <main-input-dialog
      v-if="isDialogLoaded"
      :is-visible.sync="isDialogVisible"
      :inputs="dialogInputs"
      :title-translation="$i18n.t('dialog.registerDataSource')"
      agree-text="dialog.agreeRegister"
      :loading="isLoading"
      @agree="regiterSqlViewHandler"
    />
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'DataSourcesSqlSettings',
  components: { AdminWrapper, DataInput, MainInputDialog: () => import('@/components/MainInputDialog') },
  data: () => ({
    sqlView: '',
    isFetched: false,
    isLoading: false,
    isDialogLoaded: false,
    isDialogVisible: false,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@DATASOURCES_SQL.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@datasources_sql_module_enabled'),
    moduleEnabler() {
      return {
        name: 'datasources_sql_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle2', { suffix: this.additionalModuleName }),
      };
    },
    sqlViews: get('sql/sqlViews'),
    inputs() {
      return [
        {
          name: 'sqlView',
          label: this.$i18n.t('admin.viewFromDatabase'),
          dataType: { name: 'select' },
          items: this.sqlViews,
          hideDetails: true,
          isNamedSlot: false,
        },
      ];
    },
    dialogInputs() {
      return [
        {
          name: 'dataSource',
          translationPath: 'dialog.body.dataSourceName',
          subtitle: 'dialog.body.dataSourceNameSubtitle',
          dataType: { name: 'text' },
          rules: [v => !!v || v == '0' || 'rules.required'],
          cols: '12',
          align: 'start',
        },
      ];
    },
  },
  watch: {
    isModuleEnabled: {
      handler(nV) {
        if (nV) {
          this.isFormFetched = false;
          this.init();
        } else {
          this.isFetched = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getSqlViews: call('sql/getSqlViews'),
    regiterSqlView: call('sql/regiterSqlView'),
    openDialog() {
      this.isDialogLoaded = true;
      this.isDialogVisible = true;
    },
    async regiterSqlViewHandler() {
      this.isLoading = true;
      try {
        await this.regiterSqlView({ view_name: this.sqlView, verbose_name: this.dialogInputs[0].value });
        this.isLoading = false;
        this.sqlView = '';
        this.dialogInputs[0].value = '';
        this.isDialogLoaded = false;
        this.isDialogVisible = false;
      } catch {
        this.isLoading = false;
      }
    },
    async init() {
      await Promise.all([this.getDataSources({ with_attributes_schema: false }), this.getSqlViews()]);
      this.isFetched = true;
    },
  },
};
</script>
